import React from "react";

import {
  SiTiktok,
  SiFacebook,
  SiInstagram,
  SiSnapchat,
  SiLinkedin,
  SiTwitter,
  SiTwitch,
  SiYoutube,
} from "react-icons/si";

const SocialLinks = ({ pageDetails, themeFontColor, isPredefined }) => {
  return (
    <div className="page-social-icons">
      {pageDetails.SocialLinks &&
        /* eslint-disable-next-line */
        JSON.parse(pageDetails.SocialLinks).map((social, index) => {
          if (social.type === "facebook" && social.display) {
            return (
              <a
                href={social.url}
                style={{
                  color: isPredefined
                    ? pageDetails.ThemeFontColor
                    : themeFontColor,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiFacebook />
              </a>
            );
          }
          if (social.type === "instagram" && social.display) {
            return (
              <a
                href={`https://www.instagram.com/${social.url}`}
                style={{
                  color: isPredefined
                    ? pageDetails.ThemeFontColor
                    : themeFontColor,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiInstagram />
              </a>
            );
          }
          if (social.type === "tiktok" && social.display) {
            return (
              <a
                href={`https://www.tiktok.com/@${social.url}`}
                style={{
                  color: isPredefined
                    ? pageDetails.ThemeFontColor
                    : themeFontColor,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiTiktok />
              </a>
            );
          }
          if (social.type === "twitter" && social.display) {
            return (
              <a
                href={`https://twitter.com/${social.url}`}
                style={{
                  color: isPredefined
                    ? pageDetails.ThemeFontColor
                    : themeFontColor,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiTwitter />
              </a>
            );
          }
          if (social.type === "youtube" && social.display) {
            return (
              <a
                href={social.url}
                style={{
                  color: isPredefined
                    ? pageDetails.ThemeFontColor
                    : themeFontColor,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiYoutube />
              </a>
            );
          }
          if (social.type === "linkedin" && social.display) {
            return (
              <a
                href={`${social.url}`}
                style={{
                  color: isPredefined
                    ? pageDetails.ThemeFontColor
                    : themeFontColor,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiLinkedin />
              </a>
            );
          }
          if (social.type === "snapchat" && social.display) {
            return (
              <a
                href={`https://www.snapchat.com/add/${social.url}`}
                style={{
                  color: isPredefined
                    ? pageDetails.ThemeFontColor
                    : themeFontColor,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiSnapchat />
              </a>
            );
          }
          if (social.type === "twitch" && social.display) {
            return (
              <a
                href={`https://www.twitch.tv/${social.url}`}
                style={{
                  color: isPredefined
                    ? pageDetails.ThemeFontColor
                    : themeFontColor,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiTwitch />
              </a>
            );
          }
        })}
    </div>
  );
};

export default SocialLinks;
